(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.handleClose = this.handleClose.bind(this);
      this.rebuildMarquee = this.rebuildMarquee.bind(this);
      this.applyOffsets = this.applyOffsets.bind(this);
      this.resetOffsets = this.resetOffsets.bind(this);
      this._ro = null;
    }

    connectedCallback() {
      const id = this.dataset.announcementId;

      // Persist closed state
      try {
        if (id && localStorage.getItem(`announcement_closed_${id}`) === '1') {
          this.remove();
          this.resetOffsets();
          return;
        }
      } catch (e) {}

      const btn = this.querySelector('[data-close-announcement]');
      if (btn) btn.addEventListener('click', this.handleClose);

      // Build marquee first, then apply offsets (so height is accurate)
      this.rebuildMarquee();
      requestAnimationFrame(() => this.applyOffsets());

      const viewport = this.querySelector('.announcement-marquee__viewport');
      if (viewport && 'ResizeObserver' in window) {
        this._ro = new ResizeObserver(() => {
          this.rebuildMarquee();
          this.applyOffsets();
        });
        this._ro.observe(viewport);
      } else {
        window.addEventListener('resize', this.rebuildMarquee, { passive: true });
        window.addEventListener('resize', this.applyOffsets, { passive: true });
      }
    }

    disconnectedCallback() {
      const btn = this.querySelector('[data-close-announcement]');
      if (btn) btn.removeEventListener('click', this.handleClose);

      if (this._ro) this._ro.disconnect();
      window.removeEventListener('resize', this.rebuildMarquee);
      window.removeEventListener('resize', this.applyOffsets);
    }

    getBarHeight() {
      return this.offsetHeight || 0;
    }

    applyOffsets() {
      const h = this.getBarHeight();
      document.documentElement.style.setProperty('--ab-height', `${h}px`);

      // Offset fixed/sticky header-like elements
      const headerCandidates = [
        document.querySelector('#shopify-section-header'),
        document.querySelector('header'),
        document.querySelector('.header'),
        document.querySelector('.header-wrapper'),
        document.querySelector('.shopify-section-header'),
        document.querySelector('.f-header'),
        document.querySelector('.m-header')
      ].filter(Boolean);

      headerCandidates.forEach(el => {
        const cs = window.getComputedStyle(el);
        const pos = cs.position;
        if (pos === 'fixed' || pos === 'sticky') {
          el.style.top = `${h}px`;
          el.style.zIndex = '10000'; // keep under announcement bar
        }
      });

      // Offset fixed drawers/menus
      const drawerSelectors = [
        '.menu-drawer',
        '.drawer',
        '.drawer__inner',
        '.mobile-nav',
        '.mobile-navigation',
        '.header__drawer',
        '.m-drawer',
        '.f-drawer',
        '.f-drawer__inner'
      ];

      drawerSelectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
          const cs = window.getComputedStyle(el);
          if (cs.position === 'fixed') {
            el.style.top = `${h}px`;
            el.style.height = `calc(100% - ${h}px)`;
          }
        });
      });
    }

    resetOffsets() {
      document.documentElement.style.setProperty('--ab-height', `0px`);

      const resetSelectors = [
        '#shopify-section-header',
        'header',
        '.header',
        '.header-wrapper',
        '.shopify-section-header',
        '.f-header',
        '.m-header',
        '.menu-drawer',
        '.drawer',
        '.drawer__inner',
        '.mobile-nav',
        '.mobile-navigation',
        '.header__drawer',
        '.m-drawer',
        '.f-drawer',
        '.f-drawer__inner'
      ];

      resetSelectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
          el.style.top = '';
          el.style.height = '';
          el.style.zIndex = '';
        });
      });
    }

    handleClose() {
      const id = this.dataset.announcementId;
      try {
        if (id) localStorage.setItem(`announcement_closed_${id}`, '1');
      } catch (e) {}

      this.remove();
      this.resetOffsets();
    }

    rebuildMarquee() {
      const viewport = this.querySelector('.announcement-marquee__viewport');
      const track = this.querySelector('.announcement-marquee__track');
      const sourceGroup = this.querySelector('[data-marquee-group]');

      if (!viewport || !track || !sourceGroup) return;

      track.querySelectorAll('[data-marquee-clone="true"]').forEach(n => n.remove());

      const viewportWidth = viewport.clientWidth;
      const sourceWidth = sourceGroup.scrollWidth;

      if (!sourceWidth || sourceWidth < 10) {
        requestAnimationFrame(() => this.rebuildMarquee());
        return;
      }

      const makeClone = () => {
        const clone = sourceGroup.cloneNode(true);
        clone.setAttribute('data-marquee-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach(a => a.setAttribute('tabindex', '-1'));
        track.appendChild(clone);
      };

      makeClone();

      while (track.scrollWidth < (viewportWidth * 2 + sourceWidth)) {
        makeClone();
      }

      this.style.setProperty('--ab-marquee-distance', `${sourceWidth}px`);

      const baseSeconds = parseFloat(this.dataset.speedBase || '18');
      const duration = (sourceWidth / 1000) * baseSeconds;
      this.style.setProperty('--ab-marquee-duration', `${Math.max(duration, 6).toFixed(2)}s`);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();
})();
